// @ts-nocheck
import { createContext } from 'react';
import { AccordionIconSizes, ActiveTabStateParams, HeadingAsOptions } from '../types';

export interface AccordionContextProps {
  headingAs?: HeadingAsOptions;
  accordionId?: string;
  iconSize?: AccordionIconSizes;
  activeTabIDs: Array<string>;
  setActiveState: ({ elementID, newTabState }: ActiveTabStateParams) => void;
  compact?: boolean;
  collapsible?: boolean;
}

export const AccordionContext = createContext<AccordionContextProps>(null);
